import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CameraState {
  cameraStream: MediaStream | null;
  isVideoOn: boolean;
  setCameraStream: (stream: MediaStream | null) => void;
  clearCameraStream: () => void;
  setIsVideoOn: (isVideoOn: boolean) => void;
  resetCameraState: () => void;
}

export const useCameraStore = create<CameraState>()(
  persist(
    (set, get) => ({
      cameraStream: null,
      isVideoOn: false,
      setCameraStream: (stream) => set({ cameraStream: stream }),
      clearCameraStream: () => {
        const current = get().cameraStream;
        if (current) {
          // Stop all tracks before clearing
          current.getTracks().forEach((track) => track.stop());
        }
        set({ cameraStream: null });
      },
      setIsVideoOn: (isVideoOn) => set({ isVideoOn }),
      resetCameraState: () => {
        const current = get().cameraStream;
        if (current) {
          // Stop all tracks before clearing
          current.getTracks().forEach((track) => track.stop());
        }
        set({ cameraStream: null, isVideoOn: false });
      },
    }),
    {
      name: 'camera-store',
      // Only persist the isVideoOn state, not the stream (which can't be serialized)
      partialize: (state) => ({ isVideoOn: state.isVideoOn }),
    },
  ),
);
